/* =====================================================================
   Superette × Fish Wishlist v2 — card bookmark upgrade (v1.0)
   ⚠ JavaScript. Never paste into the Fish Wishlist Custom CSS box.
   Cards drawn in JavaScript (product recommendations, complete the look, recently viewed,
   Tagalys widgets / search / listing) still print the old Fish v1 bookmark
   (.osc-css .button-collection-wishlist), which opened the old wishlist drawer.
   This swaps each one for the Fish v2 <wishlist-button> the Liquid cards use, so every
   card opens the new save drawer. Variant ids come from the ProductJson the card already prints.
   ===================================================================== */
(() => {
  const variantIds = (old, productId) => {
    const scope = (old.closest('.osc-css') && old.closest('.osc-css').parentElement) || document;
    const json = scope.querySelector(`#ProductJson-${productId}`) || document.getElementById(`ProductJson-${productId}`);
    try { return (JSON.parse(json.textContent).variants || []).map((v) => v.id).join(','); } catch (e) { return ''; }
  };
  const upgrade = () => {
    document.querySelectorAll('.osc-css .button-collection-wishlist[data-product-id]').forEach((old) => {
      const ids = variantIds(old, old.dataset.productId);
      if (!ids) return;
      const btn = document.createElement('wishlist-button');
      btn.className = 'position-absolute top-right';
      btn.dataset.variantId = ids;
      old.replaceWith(btn);
    });
  };
  const init = () => {
    upgrade();
    let queued = false;
    new MutationObserver(() => {
      if (queued) return;
      queued = true;
      setTimeout(() => { queued = false; upgrade(); }, 100);
    }).observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
